import { render } from "./New.vue?vue&type=template&id=42f6b4d8&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-42f6b4d8"

export default script